import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LikeCounter from "../LikeCounter/LikeCounter";
import FallbackImage from "../FallbackImage/FallbackImage";
import PropTypes from "prop-types";
import styles from "./Memory.module.css";
import { API_BASE } from "../../../utils/api";

const Memory = ({
  art,
  description,
  title,
  price,
  memoryDate,
  id,
  uuid,
  descriptor,
  initialLikeCount,
  userLiked,
  all = 0,
  available = 0,
  showBuyButton = true,
  fullPath = false
}) => {
  const [liked, setLiked] = useState(userLiked);
  const [likeCount, setLikeCount] = useState(initialLikeCount);

  const navigate = useNavigate();

  const handleContainerClick = () => {
    if (showBuyButton) {
      navigate(`/nft-buy/${descriptor}`);
    }
  };

  const handleBuyClick = (e) => {
    e.stopPropagation();
    navigate(`/buy/${descriptor}`);
  };

  const handleLikeClick = (e) => {
    e.stopPropagation();
    setLiked(!liked);
    setLikeCount(prevCount => liked ? prevCount - 1 : prevCount + 1);
  };

  return (
    <Box className={styles.memory1} onClick={handleContainerClick}>
      <Box className={styles.bg} />

      <Box className={styles.buttonsIconLabelTranspParent}>
        {memoryDate && (
          <Box className={styles.elementTagsBg}>
            <Typography className={styles.tag}>
              {memoryDate}
            </Typography>
          </Box>
        )}
        <LikeCounter 
          id={uuid}
          initialLikes={initialLikeCount}
          isLiked={userLiked}
          whiteBackground={false} 
        />
      </Box>

      {fullPath ? (
        <Box className={styles.imageWrapper}>
          <FallbackImage className={styles.artIcon} loading="lazy" alt="" src={`${art}`} />
          {all > 0 && available === 0 && (
            <Box className={styles.soldOutBanner}>Sold Out</Box>
          )}
        </Box>
      ) : (
        <Box className={styles.imageWrapper}>
          <FallbackImage className={styles.artIcon} loading="lazy" alt="" src={`${API_BASE}${art}`} />
          {all > 0 && available === 0 && (
            <Box className={styles.soldOutBanner}>Sold Out</Box>
          )}
        </Box>
      )}

      <Box className={styles.texts}>
        <Box className={styles.toptext}>
          <Box className={styles.title}>{title}</Box>
          <Box className={styles.description}>{description}</Box>
        </Box>
        <Box className={styles.price}>
          <Typography variant="inherit" component="span">
            Price:
          </Typography>
          <Typography variant="inherit" component="span" className={styles.boldText}>
            {" "}
            ${price}
          </Typography>
        </Box>
        <Box className={styles.availability}>
          <Typography variant="inherit" component="span">
            {all > 0
              ? available === 0
                ? ""
                : `Available: ${available}/${all}`
              : "Unlimited"}
          </Typography>
        </Box>
      </Box>

      {showBuyButton && (
        <Box className={styles.buttonholder}>
          {all > 0 && available === 0 ? (
            <Typography className={styles.soldOutText}>SOLD OUT</Typography>
          ) : (
            <Button
              className={styles.button}
              disableElevation
              variant="contained"
              onClick={handleBuyClick}
            >
              BUY
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

Memory.propTypes = {
  art: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  descriptor: PropTypes.string.isRequired,
  initialLikeCount: PropTypes.number,
  userLiked: PropTypes.bool,
};

Memory.defaultProps = {
  initialLikeCount: 0,  // Default to 0 if not provided
  userLiked: false,     // Default to false if not provided
};

export default Memory;